module.exports = __webpack_public_path__ + "527610a86010ef0621c288a3c6bb7b54.png";